/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconRevolver: {
  name: 'revolver';
  data: string;
} = {
  name: 'revolver',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M441.799 261.899h155.316l-.594-61.847h-11.846v-59.551c-32.713 7.465-62.744 21.847-81.107 59.551H358.479v-.004l-244.147.016c-5.374 19.637-9.364 34.455-12.933 46.298-24.313-14.905-84.748-55.53-84.748-55.53 8.497 44.476 28.611 80.198 57.751 109.111-5.652 6.804-12.658 14.41-21.737 24.182-49.873 94.466-40.928 144.37-37.53 196.234 32.809 41.585 98.41 39.732 137.843 25.959-1.253-57.638 7.683-112.634 47.107-168.874 48.279 44.727 122.017 23.421 157.554-15.599 15.934-17.497 18.176-38.135 15.619-61.341h68.541v-38.605z"/></svg>`,
};
